import type { PaymentMethod } from '@openeducation/pp-rn-shared-types';
import { atom } from 'jotai';

export const pendingPaymentIdAtom = atom<number | null>(null);
export const pendingPaymentAtom = atom<PaymentMethod | null>(null);
